import { supabase } from "../../../app/supabaseClient";
import neo4jApi from "../supabaseSlice";

const usersApi = neo4jApi.injectEndpoints({
  endpoints: (build) => ({
    getSingleUser: build.query({
        queryFn: async (id) => {
            const response = await supabase.from("users").select("*").eq("id", id).single();
            if (response.error) {
                throw response.error;
            }
            return {data: response.data};
        }
    }),
  })
});

export const { useGetSingleUserQuery, useLazyGetSingleUserQuery } = usersApi;